import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Row, Col } from "react-bootstrap";
import Formsy from "formsy-react";

import orderBy from "lodash/orderBy";
import moment from "moment";

import ExpenseFormRow from "./ExpenseFormRow";
import * as userActions from "../../actions/userActions";
import * as codeActions from "../../actions/codeActions";
import * as customerActions from "../../actions/customerActions";
import * as modalActions from "../../actions/modalActions";
import * as projectActions from "../../actions/projectActions";
import * as expenseActions from "../../actions/expenseActions";

import DatePicker from "../common/DatePicker";

import DropdownSearch from "../common/DropdownSearch";

import { formatDate } from "../../helpers/date";

class ExpenseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      canSubmit: false,
      rows: [{ id: 0 }]
    };
  }

  componentDidMount = () => {
    const { users, codes, actions, projects } = this.props;
    actions.loadCustomers();
    if (!users.length) actions.loadUsers();
    if (!codes.length) actions.loadCodes();
    if (!projects.length) actions.loadProjects();
  };

  onChangeDate = (date, name) => {
    this.setState({ [name]: formatDate(date, "yyyy-MM-dd") });
  };

  onChange = (field, selected) => {
    this.setState({ [field]: selected.value });

    // load customer specific projects
    if (field === "customer") {
      this.props.actions.loadProjects({ customer: selected.value });
    }
  };

  cancel = () => {
    this.props.onCancel();
  };

  generateCodeOptions = (entity, field) => {
    const codeOptions = this.props.codes
      .filter((codes) => codes.entity === entity && codes.field === field)
      .map((code) => ({ value: code._id, label: code.label }));

    return orderBy(codeOptions, [(option) => option.label.toLowerCase()]);
  };

  enableButton = () => this.setState({ canSubmit: true });

  disableButton = () => this.setState({ canSubmit: false });

  // add receipt fo specific row
  addNewReceipt = (receipt) => {
    const { id } = receipt;
    const state = `receipt${id}`;
    this.setState({ [state]: receipt });
  };

  addExpenseRow = () => {
    const index = this.state.rows.length + 1;
    const rows = [...this.state.rows, { id: index }];
    this.setState({ rows });
  };

  removeExpenseRow = (x) => {
    if (this.state.rows.length > 1) {
      const updatedRows = [...this.state.rows]
        .filter((row) => row.id !== x)
        .map((row, i) => ({ ...row, id: i }));
      this.setState({ rows: updatedRows });
    }
  };

  // add new expense(s)
  add = (model) => {
    const rows = [];
    const { codes } = this.props;
    const sumbmittedStatus = codes?.find(
      (c) =>
        c.label === "Submitted" &&
        c.field === "status" &&
        c.entity === "Expenses"
    );
    for (let i = 0; i < model.category.length; i += 1) {
      if (model.category[i]) {
        const state = `receipt${i}`;
        const receipt = this.state[state];
        if (receipt) {
          delete receipt.id;
        }
        rows[i] = {
          ...rows[i],
          category: model.category[i],
          quantity: model.quantity[i],
          amount: model.amount[i],
          total: model.total[i],
          description: model.description[i],
          bill_to_customer: model.bill_to_customer[i],
          reimburse_to_employee: model.reimburse_to_employee[i],
          occurs_annually: model.occurs_annually[i],
          status: sumbmittedStatus?.id,
          employee: this.props.expense._id
            ? this.props.expense.employee._id
            : this.props.auth.user._id,
          date: moment(model.date).toDate(),
          customer: model.customer,
          project: model.project,
          receipt
        };
        this.props.onAdd(rows[i]);
      }
    }
  };

  // save one edited expense
  save = (model) => {
    const { expense } = this.props;
    const id = expense._id;
    const receiptId = `receipt${id}`;

    const receipt = this.state[receiptId];

    const newExpense = {
      ...expense,
      category: model.category[0],
      quantity: model.quantity[0],
      amount: model.amount[0],
      total: model.total[0],
      description: model.description[0],
      bill_to_customer: model.bill_to_customer[0],
      reimburse_to_employee: model.reimburse_to_employee[0],
      occurs_annually: model.occurs_annually[0],
      employee: expense._id ? expense.employee._id : this.props.auth.user._id,
      date: moment(model.date).toDate(),
      customer: model.customer,
      project: model.project,
      receipt: !receipt ? expense.receipt : receipt
    };

    this.props.onSave(newExpense);
  };

  render() {
    const { adding, expense, editing, codes, auth } = this.props;
    const rows = expense._id ? [expense] : this.state.rows;
    const removeDisabled = rows.length <= 1;
    return (
      <Formsy
        className="vertical form"
        onValidSubmit={adding ? this.add : this.save}
        onValid={this.enableButton}
        onInvalid={this.disableButton}
      >
        <Row>
          <Col md={12} xs={12}>
            <fieldset>
              {expense.employee ? (
                <legend>Expense By {expense.employee.full_name}</legend>
              ) : (
                <legend>Expense By {this.props.auth.user.full_name}</legend>
              )}
            </fieldset>
          </Col>
          {adding && (
            <Col xs={12}>
              <strong>Customer Information:</strong>
            </Col>
          )}
          <Col md={4} xs={12}>
            <DropdownSearch
              required
              name="customer"
              label="Customer"
              value={this.state.customer || expense.customer}
              onChange={this.onChange}
              data={orderBy(
                this.props.customers.map((customer) => ({
                  value: customer._id,
                  label: customer.name
                })),
                [(option) => option.label.toLowerCase()]
              )}
              disabled={!editing || (adding && this.props.customer)}
            />
          </Col>
          <Col md={4} xs={12}>
            <DropdownSearch
              name="project"
              label="Project"
              value={this.state.project || expense.project}
              onChange={this.onChange}
              data={orderBy(
                this.props.projects.map((project) => ({
                  value: project._id,
                  label: project.name
                })),
                [(option) => option.label.toLowerCase()]
              )}
              disabled={!editing || (adding && this.props.project)}
            />
          </Col>
          <Col md={4} xs={12}>
            <DatePicker
              required
              name="date"
              label="date"
              onChange={this.onChangeDate}
              value={this.state.date || moment(expense.date)}
              disabled={!editing}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            {adding && (
              <React.Fragment>
                <strong>Expense(s):</strong>
                <hr />
              </React.Fragment>
            )}

            {rows.map((row, i) =>
              row ? (
                <ExpenseFormRow
                  row={row}
                  adding={adding}
                  editing={editing}
                  index={i}
                  key={i}
                  isTerminal={i === rows.length - 1}
                  removeDisabled={removeDisabled}
                  generateCodeOptions={this.generateCodeOptions}
                  removeExpenseRow={this.removeExpenseRow}
                  addExpenseRow={this.addExpenseRow}
                  addNewReceipt={this.addNewReceipt}
                  codes={codes}
                  expense={expense}
                  auth={auth}
                />
              ) : null
            )}
          </Col>
        </Row>
        {editing && (
          <Row>
            <Col md={12} className="footer">
              <button
                className="btn  btn-cancel"
                type="button"
                onClick={this.cancel}
              >
                Cancel
              </button>
              <React.Fragment>
                {!this.props.adding && (
                  <input
                    className="btn btn-success"
                    type="submit"
                    disabled={!this.state.canSubmit || this.props.saving}
                    value={this.props.saving ? "Saving... " : "Save"}
                  />
                )}
                {this.props.adding && (
                  <input
                    className="btn btn-success"
                    type="submit"
                    disabled={!this.state.canSubmit || this.props.saving}
                    value={this.props.saving ? "Adding... " : "Add"}
                  />
                )}
              </React.Fragment>
            </Col>
          </Row>
        )}
      </Formsy>
    );
  }
}

ExpenseForm.propTypes = {
  customer: PropTypes.object,
  actions: PropTypes.object,
  adding: PropTypes.bool,
  editing: PropTypes.bool,
  expense: PropTypes.object,
  users: PropTypes.array,
  codes: PropTypes.array,
  projects: PropTypes.array,
  auth: PropTypes.object,
  saving: PropTypes.bool,
  customers: PropTypes.array,
  project: PropTypes.object,
  onSave: PropTypes.func,
  onAdd: PropTypes.func,
  onCancel: PropTypes.func
};

const mapStatesToProps = (state) => ({
  state: state.reducers,
  customers: state.reducers.customers,
  projects: state.reducers.projects,
  expenses: state.reducers.expenses,
  expenseReceiptToDelete: state.reducers.expenseReceiptToDelete
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...modalActions,
      ...customerActions,
      ...userActions,
      ...codeActions,
      ...projectActions,
      ...expenseActions
    },
    dispatch
  )
});

export default connect(mapStatesToProps, mapDispatchToProps)(ExpenseForm);
